import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

/**
 * A goods removal (enlèvement marchandises) as returned by
 * GET /goods_removal_controls. Every field is optional: the API only serializes
 * what the normalization context of the operation carries.
 */
export type GatePassItemData = {
  "@id"?: string;
  "@type"?: string;
  id?: number;
  reference?: string;
  createdAt?: string;

  /** IRI of the exit note (bon de sortie) this removal is on, or null. */
  exitNote?: string | null;

  /** Embedded as an object thanks to the 'storageLoad:select' group. */
  storageLoad?: any;

  /** Flattened getter on the API side (storageLoad.uniqueIdentifierLoad). */
  uniqueIdentifierLoad?: string;

  /** Enum serialized as { id, name } through the 'enum:content' group. */
  removalSource?: { id?: string; name?: string } | null;
  vehicleType?: { id?: string; name?: string } | null;

  /**
   * Serialized as an IRI: GoodsRemovalControl's contexts do not carry the
   * 'customer:select' group, so the name is only readable once the backend
   * adds it to the list/read normalization contexts.
   */
  customer?: any;

  /** Embedded through the 'material:select' group. */
  truck?: { reference?: string } | null;

  particularTruckNumber?: string;
  particularDriverName?: string;
  driverLicenseNumber?: string;
  driverIdCardNumber?: string;

  quantityOut?: string;
  bagCount?: number;
  invoiceNumber?: string;
  carrierName?: string;
  forwarderAgentName?: string;

  /** Embedded through the 'user:select' group. */
  checkedBy?: { fullname?: string; email?: string } | null;

  comment?: string;
  damages?: any[];
  images?: any[];
};

export const initialGatePassPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
};
